export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14084.ee0ea095.jpg";